import { Restaurant } from '@material-ui/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import tPaths from './tPaths';

export type TKeys =
  | 'carrierBundle'
  | 'country'
  | 'dataAmount'
  | 'lastEditDate'
  | 'origin'
  | 'price'
  | 'region'
  | 'status'
  | 'title'
  | 'iso'
  | 'city'
  | 'athlete'
  | 'featured'
  | 'dateOfBirth'
  | 'email'
  | 'hasESim'
  | 'nameSurname'
  | 'rbmNumber'
  | 'referralCode'
  | 'registrationDate'
  | 'esimNumber'
  | 'userId'
  | 'phone'
  | 'totalData'
  | 'usedData'
  | 'destination'
  | 'activationDate'
  | 'validUntil'
  | 'autoRenewing'
  | 'variations'
  | 'name'
  | 'id'
  | 'carrierSubscriberReference'
  | 'delete'
  | 'activationDate'
  | 'code'
  | 'assignedTo'
  | 'activity'
  | 'heavy'
  | 'moderate'
  | 'rare'
  | '_id'
  | 'group'
  | 'label'
  | 'marketingName'
  | 'image'
  | 'jsxCheckbox'
  | 'reservedBy'
  | 'createdAt'
  | 'commercialCode'
  | 'technicalCode'
  | 'customersCountWhoInstalledApp'
  | 'partnerCampaign'
  | 'rewardType'
  | 'rewardThreshold'
  | 'totalPrice'
  | 'body'
  | 'insertedCount'
  | 'usedCount'
  | 'action'
  | 'internalName'
  | 'publicCode'
  | 'type'
  | 'codeType'
  | 'targetPackage'
  | 'generatedCodeCount'
  | 'insertedCodeCount'
  | 'usedCodeCount';

type CustomColumn = { accessorAsHeader: TKeys; customHeader?: any };

const useColumnsHeaders = (headers: CustomColumn[]) => {
  const { t } = useTranslation();
  return headers.map(({ accessorAsHeader, customHeader }) => {
    return {
      accessor: accessorAsHeader,
      Header: customHeader || t(tPaths.columnsNames[accessorAsHeader]),
    };
  });
};

export default useColumnsHeaders;

// const useColumnsHeaders = (keys: TKeys[]) => {
//   const { t } = useTranslation();
//   return keys.map((key) => ({
//     accessor: key,
//     Header: t(tPaths.columnsNames[key]),
//   }));
// };
// export default useColumnsHeaders;
